import React from "react";
import PageHeader from "../components/PageHeader";
import { COMPANY } from "../mock/data";
import { ShieldCheck, Target, Users, Sparkles, Globe } from "lucide-react";

export default function About() {
  const values = [
    { icon: ShieldCheck, title: "Security First", desc: "Every product decision starts with your safety and privacy in mind." },
    { icon: Target, title: "Customer-Obsessed", desc: "We measure success by how safe and confident our users feel every day." },
    { icon: Sparkles, title: "Innovation", desc: "We push the boundaries of mobile security with AI-driven detection." },
    { icon: Users, title: "Transparency", desc: "Clear policies, honest pricing, and open communication — always." }
  ];

  return (
    <>
      <PageHeader
        eyebrow="About Us"
        title={`Meet ${COMPANY.brand}`}
        subtitle="We build mobile security tools people actually love using — lightweight, private, and always on."
      />

      <section className="py-14 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <span className="text-xs uppercase tracking-widest text-emerald-700 font-semibold">Our Story</span>
          <h2 className="section-title mt-2 text-3xl font-extrabold text-slate-900">Protecting Android users, one device at a time</h2>
          <div className="mt-4 space-y-4 text-slate-600 leading-relaxed">
            <p>
              {COMPANY.brand} was created with a single mission: make world-class mobile security accessible to every Android user — without draining their battery, slowing their phone, or invading their privacy.
            </p>
            <p>
              Our team of security researchers, engineers, and support specialists work around the clock so you don&apos;t have to worry about malware, spyware, or data theft.
            </p>
            <p>
              Today, we protect users in more than 40 countries with a lightweight, AI-powered antivirus that respects your privacy and keeps your phone running fast.
            </p>
          </div>
        </div>
      </section>

      <section className="py-14 bg-slate-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="section-title text-3xl font-extrabold text-slate-900">Our Values</h2>
            <p className="mt-3 text-slate-600">Principles that guide every product decision we make.</p>
          </div>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v) => (
              <div key={v.title} className="feature-card rounded-2xl bg-white border border-slate-200 p-6">
                <div className="h-11 w-11 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center">
                  <v.icon className="h-5 w-5" />
                </div>
                <h3 className="mt-4 font-semibold text-slate-900">{v.title}</h3>
                <p className="mt-1 text-sm text-slate-600 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <Globe className="h-10 w-10 mx-auto text-emerald-600" />
          <h2 className="section-title mt-4 text-3xl font-extrabold text-slate-900">Available Worldwide</h2>
          <p className="mt-3 text-slate-600">Serving users across North America, Europe, Asia, and beyond with round-the-clock expert support.</p>
        </div>
      </section>
    </>
  );
}
